var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "guest-management" },
    [
      _c(
        "div",
        { staticClass: "search-area" },
        [
          _c(
            "el-form",
            {
              staticClass: "search-form",
              attrs: { inline: true, model: _vm.searchForm },
            },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "shop-select",
                      attrs: {
                        placeholder: "请选择门店",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.searchForm.storeId,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "storeId", $$v)
                        },
                        expression: "searchForm.storeId",
                      },
                    },
                    _vm._l(_vm.storeList, function (shop) {
                      return _c("el-option", {
                        key: shop.storeId,
                        attrs: { label: shop.storeName, value: shop.storeId },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("搜索")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择模板", clearable: "" },
                      model: {
                        value: _vm.searchForm.template,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "template", $$v)
                        },
                        expression: "searchForm.template",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "有背景", value: "1" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "无背景", value: "2" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.downloadTemplate },
                },
                [_vm._v("下载二维码")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.downloadImportTemplateFile },
                },
                [_vm._v("下载导入模板")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "action-buttons" },
            [
              _c("el-button", { on: { click: _vm.exportData } }, [
                _vm._v("导出数据"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "success" },
                  on: { click: _vm.openImportDialog },
                },
                [_vm._v("导入数据")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.openFastTableDialog },
                },
                [_vm._v("创建快餐客位码")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "warning" }, on: { click: _vm.pauseSeats } },
                [_vm._v("同步客位码")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: this.tableLoading,
              expression: "this.tableLoading",
            },
          ],
          staticClass: "guest-table",
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "index",
              label: "编号",
              align: "center",
              width: "50",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "storeName", label: "店面", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "thirdTableId",
              label: "POS客位编号",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "tableName", label: "客位名称", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "area", label: "客位区域", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "number", label: "容纳人数", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "saleWay", label: "销售方式", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("el-tag", [_vm._v(_vm._s(scope.row.saleWay))])]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "qrCode", label: "二维码", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-image", {
                      staticClass: "qr-code",
                      attrs: {
                        src: scope.row.previewImage,
                        "preview-src-list": [scope.row.qrcode],
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              label: "操作",
              align: "center",
              width: "200",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.deleteEdit(scope.row)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-wrapper" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "导入客位数据",
            visible: _vm.importDialogVisible,
            width: "400px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.importDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            [
              _c(
                "el-form-item",
                { attrs: { label: "选择Excel文件" } },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "upload",
                      attrs: {
                        "auto-upload": false,
                        "on-change": _vm.handleFileChange,
                        "file-list": _vm.fileList,
                        accept: ".xls,.xlsx",
                        action: "#",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { size: "small", type: "primary" } },
                        [_vm._v("点击上传")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "el-upload__tip",
                          attrs: { slot: "tip" },
                          slot: "tip",
                        },
                        [_vm._v("只能上传xls/xlsx文件，且不超过10MB")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.importDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.importData } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "创建快餐客位码 - 选择区域",
            visible: _vm.areaSelectDialogVisible,
            width: "500px",
            "before-close": _vm.closeAreaSelectDialog,
          },
          on: {
            "update:visible": function ($event) {
              _vm.areaSelectDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "area-select-container" },
            [
              _c("div", { staticClass: "area-list" }, [
                _c("div", { staticClass: "area-list-title" }, [
                  _vm._v("选择已有区域"),
                ]),
                _vm._v(" "),
                _vm.areaList.length === 0
                  ? _c("div", { staticClass: "empty-area" }, [
                      _vm._v("暂无区域，请新建"),
                    ])
                  : _c(
                      "div",
                      { staticClass: "area-items" },
                      _vm._l(_vm.areaList, function (area) {
                        return _c(
                          "div",
                          {
                            key: area.areaId,
                            staticClass: "area-item",
                            class: {
                              selected:
                                _vm.selectedArea &&
                                _vm.selectedArea.areaId === area.areaId,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.selectArea(area)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(area.areaName) +
                                "\n            "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
              ]),
              _vm._v(" "),
              _c("el-divider", [_vm._v("或")]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "newAreaFormRef",
                  attrs: {
                    model: _vm.newAreaForm,
                    rules: _vm.newAreaFormRules,
                    "label-width": "80px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "新建区域", prop: "areaName" } },
                    [
                      _c("el-input", {
                        staticStyle: {
                          width: "100px",
                          display: "inline-block",
                        },
                        attrs: {
                          placeholder: "输入字母，如：A",
                          maxlength: "1",
                        },
                        model: {
                          value: _vm.newAreaForm.areaName,
                          callback: function ($$v) {
                            _vm.$set(_vm.newAreaForm, "areaName", $$v)
                          },
                          expression: "newAreaForm.areaName",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "margin-left": "10px",
                            color: "#909399",
                          },
                        },
                        [_vm._v("区")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { type: "primary", loading: _vm.creatingArea },
                          on: { click: _vm.createNewArea },
                        },
                        [_vm._v("创建新区域")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.closeAreaSelectDialog } }, [
                _vm._v("取 消"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: !_vm.selectedArea },
                  on: { click: _vm.confirmArea },
                },
                [_vm._v("下一步")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "创建快餐客位码 - 设置参数",
            visible: _vm.fastTableDialogVisible,
            width: "600px",
            "before-close": _vm.closeFastTableDialog,
          },
          on: {
            "update:visible": function ($event) {
              _vm.fastTableDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "selected-area-info" }, [
            _vm._v("\n        已选区域："),
            _c("strong", [
              _vm._v(_vm._s(_vm.selectedArea ? _vm.selectedArea.areaName : "")),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "fastTableFormRef",
              attrs: {
                model: _vm.fastTableForm,
                rules: _vm.fastTableFormRules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "代码范围", prop: "startCode" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "100px" },
                    attrs: { min: 1, "controls-position": "right" },
                    model: {
                      value: _vm.fastTableForm.startCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.fastTableForm, "startCode", $$v)
                      },
                      expression: "fastTableForm.startCode",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticStyle: { margin: "0 10px" } }, [
                    _vm._v("-"),
                  ]),
                  _vm._v(" "),
                  _c("el-input-number", {
                    staticStyle: { width: "100px" },
                    attrs: { min: 1, "controls-position": "right" },
                    model: {
                      value: _vm.fastTableForm.endCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.fastTableForm, "endCode", $$v)
                      },
                      expression: "fastTableForm.endCode",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "排除代码" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "如：4,13,14 表示跳过4号、13号、14号",
                    },
                    model: {
                      value: _vm.fastTableForm.excludeCodesText,
                      callback: function ($$v) {
                        _vm.$set(_vm.fastTableForm, "excludeCodesText", $$v)
                      },
                      expression: "fastTableForm.excludeCodesText",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-tip" }, [
                    _vm._v("用逗号分隔要跳过的号码"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "客位码前缀" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "150px" },
                    attrs: {
                      placeholder: "如：W，生成W01A、W02A...",
                      maxlength: "5",
                    },
                    model: {
                      value: _vm.fastTableForm.prefix,
                      callback: function ($$v) {
                        _vm.$set(_vm.fastTableForm, "prefix", $$v)
                      },
                      expression: "fastTableForm.prefix",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-tip" }, [
                    _vm._v(
                      "示例：前缀W + 代码01 + A区 = W01A；无前缀则生成 A01"
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "跳过已存在" } },
                [
                  _c("el-switch", {
                    attrs: { "active-value": true, "inactive-value": false },
                    model: {
                      value: _vm.fastTableForm.skipExisting,
                      callback: function ($$v) {
                        _vm.$set(_vm.fastTableForm, "skipExisting", $$v)
                      },
                      expression: "fastTableForm.skipExisting",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-tip" }, [
                    _vm._v("开启后，已存在的客位码将被跳过；关闭后将被覆盖"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.closeFastTableDialog } }, [
                _vm._v("取 消"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.fastTableCreating },
                  on: { click: _vm.createFastTables },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.drawerTitle,
            visible: _vm.drawerVisible,
            direction: "rtl",
            size: "600px",
            "before-close": _vm.closeDrawer,
            "wrapper-closable": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "drawer-content" },
            [
              _c(
                "el-form",
                {
                  ref: "drawerFormRef",
                  staticClass: "drawer-form",
                  attrs: {
                    model: _vm.drawerForm,
                    rules: _vm.formRules,
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "店面", prop: "storeName" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "组织机构" },
                          model: {
                            value: _vm.drawerForm.storeName,
                            callback: function ($$v) {
                              _vm.$set(_vm.drawerForm, "storeName", $$v)
                            },
                            expression: "drawerForm.storeName",
                          },
                        },
                        _vm._l(_vm.storeOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "客位名称", prop: "seatName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.drawerForm.seatName,
                          callback: function ($$v) {
                            _vm.$set(_vm.drawerForm, "seatName", $$v)
                          },
                          expression: "drawerForm.seatName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "客位区域", prop: "seatArea" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.drawerForm.seatArea,
                          callback: function ($$v) {
                            _vm.$set(_vm.drawerForm, "seatArea", $$v)
                          },
                          expression: "drawerForm.seatArea",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "容纳人数", prop: "capacity" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入", type: "number" },
                        model: {
                          value: _vm.drawerForm.capacity,
                          callback: function ($$v) {
                            _vm.$set(_vm.drawerForm, "capacity", $$v)
                          },
                          expression: "drawerForm.capacity",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "二维码" } },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "upload-demo",
                          attrs: {
                            action: "#",
                            "before-upload": _vm.handleFileUpload,
                            "on-remove": _vm.handleFileRemove,
                            "file-list": _vm.fileList,
                            "list-type": "picture-card",
                            limit: 1,
                            "auto-upload": false,
                            accept: "image/*",
                          },
                        },
                        [_c("i", { staticClass: "el-icon-plus" })]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "upload-tip" }, [
                        _vm._v("图片格式：jpg/png，大小≤2MB"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "drawer-footer" },
                [
                  _c("el-button", { on: { click: _vm.closeDrawer } }, [
                    _vm._v("取消"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.saveForm } },
                    [_vm._v("确定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }